module.exports = __webpack_public_path__ + "static/media/image1.e6d9d52d.jpg";